export enum AuthenticationProvider {
  CYBERSOURCE = 0,
  POWERTRANZ = 1,
  SANDBOX = 2,
  PAYWAY = 3,
  INSWITCH = 4
}
